import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import Boxes from '../Boxes'
import DealerCards from '../DealerCards'
import Notice from '../Notice'
import OnlineStatus from '../OnlineStatus'
import { useRussianPokerStore } from '../useRussianPokerStore'
import PopupExit from './PopupExit'

const Container = styled.div<{
  visible?: boolean
}>`
  display: grid;
  grid-template-rows: 20px 1fr auto 1fr;
  height: 100%;
  visibility: ${(props) => (props.visible ? 'initial' : 'hidden')};
`

const Top = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  width: auto;
  gap: 10px;
`

const TopInfo = styled.div`
  color: rgba(255, 255, 255, 0.29);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
`

const TopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const GamePlay = observer(() => {
  const { isOnlineStatusPlayer, game, session, showPopupExit } = useRussianPokerStore()

  if (!game || !session) {
    return null
  }

  return (
    <>
      {showPopupExit && <PopupExit />}
      <Container visible={!showPopupExit}>
        <Top>
          <TopLeft>
            <TopInfo>Название: {game.name}</TopInfo>
            <TopInfo>Номер сессии: {game.sessionId}</TopInfo>
          </TopLeft>
          <OnlineStatus online={isOnlineStatusPlayer} />
        </Top>
        <Boxes />
        <Notice />
        <DealerCards />
      </Container>
    </>
  )
})

export default GamePlay
